import { db } from 'boot/firebase';
import { collection } from 'firebase/firestore';

import GenericDB from './generic-db';

export default class TreatmentAreasDB extends GenericDB {
  constructor(clinicId) {
    super('', 'clinicSettings.treatmentAreas');
    this.clinicId = clinicId;
  }

  setClinicId(clinicId) {
    this.clinicId = clinicId;
  } // setClinicId()

  getCollectionRef() {
    return collection(db, 'clinicSettings', this.clinicId, 'treatmentAreas');
  }
}
